import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_URL } from '../../configurations/server-config';

@Injectable({
  providedIn: 'root'
})
export class FreeticketService {

  constructor(private http: HttpClient) { }

  generateTicketCode(value: any): any{
    return this.http.post(`${API_URL}/freeticket`, value);
  }

  getAllfreeticket(page= 0, size= 10, sortby: any=null, orderby: any=null): any {
    return this.http.get(`${API_URL}/freeticket?page=${page}&size=${size}&sortby=${sortby}&direction=${orderby}`);
  }

  getActiveFreeCode(value: any): any {
    return this.http.get(`${API_URL}/activefreeticket?ty=${value}`);
  }

  enableTicketCode(value: any): any{
    return this.http.put(`${API_URL}/freeticket`, value);
  }
}
